function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import BigNumber from "bignumber.js";
import repeat from "lodash/repeat";
import { roundNumber } from "./roundNumber";
function replaceInFormat(format, {
  formattedNumber,
  unit
}) {
  return format.replace("%n", formattedNumber).replace("%u", unit);
}
function computeSignificand({
  significand,
  whole,
  precision
}) {
  if (whole === "0" || precision === null) {
    return significand;
  }
  const limit = Math.max(0, precision - whole.length);
  return (significand !== null && significand !== void 0 ? significand : "").substr(0, limit);
}
export function formatNumber(input, options) {
  var _a, _b, _c;
  const originalNumber = new BigNumber(input);
  if (options.raise && !originalNumber.isFinite()) {
    throw new Error(`"${input}" is not a valid numeric value`);
  }
  const roundedNumber = roundNumber(originalNumber, options);
  const numeric = new BigNumber(roundedNumber);
  const isNegative = numeric.lt(0);
  const isZero = numeric.isZero();
  let _roundedNumber$split = roundedNumber.split("."),
    _roundedNumber$split2 = _slicedToArray(_roundedNumber$split, 2),
    whole = _roundedNumber$split2[0],
    significand = _roundedNumber$split2[1];
  const buffer = [];
  let formattedNumber;
  const positiveFormat = (_a = options.format) !== null && _a !== void 0 ? _a : "%n";
  const negativeFormat = (_b = options.negativeFormat) !== null && _b !== void 0 ? _b : `-${positiveFormat}`;
  const format = isNegative && !isZero ? negativeFormat : positiveFormat;
  whole = whole.replace("-", "");
  while (whole.length > 0) {
    buffer.unshift(whole.substr(Math.max(0, whole.length - 3), 3));
    whole = whole.substr(0, whole.length - 3);
  }
  whole = buffer.join("");
  formattedNumber = buffer.join(options.delimiter);
  if (options.significant) {
    significand = computeSignificand({
      whole,
      significand,
      precision: options.precision
    });
  } else {
    significand = significand !== null && significand !== void 0 ? significand : repeat("0", (_c = options.precision) !== null && _c !== void 0 ? _c : 0);
  }
  if (options.stripInsignificantZeros && significand) {
    significand = significand.replace(/0+$/, "");
  }
  if (originalNumber.isNaN()) {
    formattedNumber = input.toString();
  }
  if (significand && originalNumber.isFinite()) {
    formattedNumber += (options.separator || ".") + significand;
  }
  return replaceInFormat(format, {
    formattedNumber,
    unit: options.unit
  });
}